function onClickEditImage(e, editImageWrapper) {
  const previewWrapper = $(e.target).closest("[data-image-index]");
  const itemIndex = previewWrapper.data("image-index");
  const itemImageId = $(e.target).closest("[data-image-id]").data("image-id");
  const editWrapper =
    editImageWrapper || $("[data-edit-id=" + itemImageId + "]");
  const previewImageWrapper = $("[data-image-index=" + itemIndex + "]");
  previewImageWrapper.addClass("hidden");
  editWrapper.removeClass("hidden");
}

function onSubmitEditImage(fieldId, dataUrl, response) {
  const photoId = response.photo.id;
  const editWrapper = $("[data-edit-id=" + photoId + "]");
  const previewWrapper = $(".largePreview[data-image-id=" + photoId + "]");
  editWrapper.addClass("hidden");
  previewWrapper.find(".carouselImage").attr("src", dataUrl);
  previewWrapper.removeClass("hidden");
  const columnImage = $(".imagesColumn").find(
    '.imagePreview[data-image-id="' + photoId + '"] img'
  );
  columnImage.attr("src", dataUrl, $(".imagesColumn"));
}

function addRemoveButtonListener() {
  $(document).on("click", ".removeButton", function (e) {
    const removeId = $(this).data("delete-image-id");
    const wrapper = $(this).closest(".imagesColumn");

    $('.imagePreview[data-image-id="' + removeId + '"]').addClass("hidden");
    const firstAvailableItemId = wrapper
      .find(".imagePreview[data-image-id]:not(.hidden)")
      .first()
      .data("image-id");

    $(this)
      .closest(".wrapperPreviewImage")
      .find(".largePreview[data-image-id]")
      .addClass("hidden");
    $(
      '.largePreview[data-image-id="' + firstAvailableItemId + '"]'
    ).removeClass("hidden");
  });
}
function addEditButtonListener() {
  $(".editImage[data-image-id] img").on("click", function (e) {
    e.stopPropagation();
    const previewWrapper = $(e.target).closest("[data-image-index]");
    const itemIndex = previewWrapper.data("image-index");
    const itemImageId = $(e.target).closest("[data-image-id]").data("image-id");

    const editWrapper = $("[data-edit-id=" + itemImageId + "]");
    const previewImageWrapper = $("[data-image-index=" + itemIndex + "]");
    previewImageWrapper.addClass("hidden");
    editWrapper.removeClass("hidden");
  });
}

$(document).ready(function () {
  $('[data-image-index="0"]').removeClass("hidden");
  $(".imagePreview[data-button-index]").on("click", function (e) {
    const imageId = $(this).closest(".imagePreview").data("image-id");
    $(this)
      .closest(".wrapperPreviewImage")
      .find(".largePreview[data-image-id]")
      .addClass("hidden");
    $('.largePreview[data-image-id="' + imageId + '"]').removeClass("hidden");
  });
  addRemoveButtonListener();
  addEditButtonListener();
});

function deleteImageAndToggleVisibility(
  previewWrapper,
  newImageButtonIndex,
  deleteButtonEvent
) {
  $.ajax({
    method: "DELETE",
    url: "/admin/photos/" + previewWrapper.data("image-id"),
  }).done(function () {
    previewWrapper.remove();
    $('[data-image-index="' + newImageButtonIndex + '"]').remove();
    $("[data-image-index]").addClass("hidden");
    const firstAvailableImageIndex = $(".imagePreview:not(.hidden)")
      .first()
      .data("button-index");
    $('[data-image-index="' + firstAvailableImageIndex + '"]')
      .first()
      .removeClass("hidden");
  });
}
